import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AuthService, IdToken } from '@auth0/auth0-angular';
import { environment } from '../../../environments/environment';
import { map, Observable } from 'rxjs';
import { User } from '../../dtos/user.dto';

interface EnrichedIdToken extends IdToken {
  userRoles?: string[];
  permissions?: string[];
  emailaddress?: string;
}

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private http = inject(HttpClient);
  private baseUrl = `${environment.api.url}/users`;

  public auth0 = inject(AuthService);
  public user?: User;
  public isAdmin$ = this.auth0.idTokenClaims$.pipe(
    map((claims: EnrichedIdToken | null | undefined) => {
      if (!claims) {
        return false;
      }

      return claims.userRoles?.includes('administrator') ?? false;
    })
  );

  constructor() {
    this.auth0.isAuthenticated$.subscribe(authenticated => {
      if (authenticated && !this.user) {
        this.getUser().subscribe(user => (this.user = user));
      }
    });
  }

  /**
   * Get user details
   *
   * @returns The user details
   */
  public getUser(): Observable<User> {
    return this.http.get<User>(`${this.baseUrl}`);
  }

  /**
   * Login the user.
   * @memberof AuthService
   */
  public login(): void {
    this.auth0.loginWithRedirect();
  }

  /**
   * SignUp the user.
   * @memberof AuthService
   */
  public signUp(): void {
    this.auth0.loginWithRedirect({ authorizationParams: { screen_hint: 'signup' } });
  }

  /**
   * Logout the user.
   * @memberof AuthService
   */
  public logout(): void {
    this.auth0.logout({
      logoutParams: {
        returnTo: window.location.origin
      }
    });
  }
}
